import { Card } from '../../../../../../../components/card/card';
import { Table } from '../../../../../../../features/table/table';
import { useLang } from '../../../../../../../hooks/use-lang';
import { useDishMenuStore } from '../../../../../../../store/use-dish-menu-store';
import s from './menu-informer-uploaded-dish-table.module.css';

export const MenuInformerUploadedDishTable = () => {
  const { t, getLocale } = useLang();
  const { uploadedMenu } = useDishMenuStore();
  const list = uploadedMenu?.preview;

  return (
    <Card className={s.feature}>
      <div className={s.header}>
        <h2>{t('Превью')}</h2>
      </div>

      <Table
        className={s.table}
        onEmpty={{
          title: t('Здесь пока пусто'),
          text: t('Загрузите файл для просмотра'),
        }}
        cols={{
          name: {
            label: t('Название'),
          },
          description: {
            label: t('Описание'),
          },
          category: {
            label: t('Категория'),
          },
          section: {
            label: t('Раздел'),
          },
          cost: { label: t('Цена') },
        }}
        rows={list?.map((item) => ({
          name: getLocale(item.dish.name),
          description: getLocale(item.dish.specs.full_desc),
          category: getLocale(item.category),
          section: getLocale(item.section),
          cost: item.dish.price,
        }))}
      />
    </Card>
  );
};
